/* PLEASE KEEP THESE FEATURE FLAGS IN ALPHABETICAL ORDER */
export const AUTOMATE_DATA_STORE_APPS = 'AutomateDataStoreApps';
export const CONSENT_MANAGER_IDME_WORKAROUND = 'ConsentManagerIDmeWorkaround';
export const ENABLE_ADMIN_HELPERS = 'EnableAdminHelpers';
export const ENABLE_ASSESSMENTS_PROJECTS = 'EnableAssessmentsProjects';
export const ENABLE_ASSESSMENTS_REPORTING = 'EnableAssessmentsReporting';
export const ENABLE_AUTO_ANSWERS = 'EnableAutoAnswers';
export const ENABLE_AUTO_DSAR_INTAKE = 'EnableAutoDsarIntake';
export const ENABLE_BILLING_PORTAL = 'EnableStripeCustomerPortal';
export const ENABLE_BREACH_DATA = 'EnableBreachData';
export const ENABLE_CMP_DASHBOARD = 'EnableCmpDashboard';
export const ENABLE_CMP_EXTERNAL_STYLESHEET = 'EnableCMPExternalStylesheet';
export const ENABLE_CMP_MODERN_BANNER_DESIGN = 'EnableCMPModernBannerDesign';
export const ENABLE_CMP_RULE_TYPES = 'EnableCMPRuleTypes';
export const ENABLE_CONSENT_PROMPTS = 'EnableConsentPrompts';
export const ENABLE_CONSUMER_SSO_PRODUCT_DROPDOWN = 'EnableConsumerSsoProductDropdown';
export const ENABLE_CUSTOM_ASSESSMENTS = 'EnableCustomAssessments';
export const ENABLE_DATA_STORES_TOP_LEVEL = 'EnableDataStoresTopLevel';
export const ENABLE_DEMO_AGENT = 'EnableDemoAgent';
export const ENABLE_DEMO_SSO_AGENT = 'EnableDemoSSO';
export const ENABLE_DEV_REV = 'EnableDevRev';
export const ENABLE_DSAR_CONDITIONAL_FIELDS = 'EnableDSARConditionalFields';
export const ENABLE_DSAR_EDIT_DIALOG = 'EnableDsarEditDialog';
export const ENABLE_DSAR_FORM_AUDIT_LOG = 'EnableDSARFormAuditLog';
export const ENABLE_DSAR_REPORTING = 'EnableDSARReporting';
export const ENABLE_DSAR_WORKFLOWS = 'EnableDSARWorkflows';
export const ENABLE_DSAR_WORKFLOW_ADVANCED_SETTINGS = 'DSARWorkflowAdvancedTab';
export const ENABLE_FORMS_DATA_VIZ_AND_EXPORT = 'EnableFormsDataVizAndExport';
export const ENABLE_INTEGRATIONS = 'EnableIntegrations';
export const ENABLE_LIMIT_CONNECTIONS = 'EnableLimitConnections';
export const ENABLE_PLATFORM_WIDE_AI_ASSISTANT = 'EnablePlatformWideAIAssistant';
export const ENABLE_PRIVACY_ADVISOR = 'EnablePrivacyAdvisor';
export const ENABLE_PRIVACY_RISK = 'EnablePrivacyRisk';
export const ENABLE_QUESTION_ASSIGNMENT = 'EnableQuestionAssignment';
export const ENABLE_REQUEST_TYPES_V2 = 'EnableRequestTypesV2';
export const ENABLE_TATTLE_SAMPLING = 'EnableTattleSampling';
export const ENABLE_TEAMS_INTEGRATION = 'EnableTeamsIntegration';
export const ENABLE_TEMPLATE_PUBLISHING = 'EnableTemplatePublishing';
export const ENABLE_TOGGLE_USERPILOT_EXPERIENCE = 'EnableToggleUserpilotExperience';
export const ENABLE_UC_DASHBOARD = 'EnableUcDashboard';
export const ENABLE_US_STATE_BANNER_FORMAT = 'EnableUsStateBannerFormat';
export const ENABLE_VENDOR_AUTOFOLLOW = 'EnableVendorAutofollow';
export const ENABLE_VENDOR_GUIDANCE = 'EnableVendorGuidance';
export const REPORTS_FEATURE_FLAG = 'EnableReports';
/* PLEASE KEEP THESE FEATURE FLAGS IN ALPHABETICAL ORDER */
